"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Factory__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
            {
                internalType: "contract ISavingsVault",
                name: "_savingsVaultImplementation",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "FailedDeployment",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "InsufficientBalance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "OwnableInvalidOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "OwnableUnauthorizedAccount",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "savingsVault",
                type: "address",
            },
        ],
        name: "SavingsVaultDeployed",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "customSavingsVaultImplementation",
                type: "address",
            },
            {
                internalType: "address",
                name: "vaultAdmin",
                type: "address",
            },
            {
                internalType: "contract IStableCoin[]",
                name: "coins",
                type: "address[]",
            },
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string",
            },
        ],
        name: "deploySavingsVault",
        outputs: [
            {
                internalType: "contract ISavingsVault",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "customSavingsVaultImplementation",
                type: "address",
            },
            {
                internalType: "address",
                name: "vaultAdmin",
                type: "address",
            },
            {
                internalType: "contract IStableCoin[]",
                name: "coins",
                type: "address[]",
            },
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string",
            },
        ],
        name: "getSavingsVaultAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "savingsVaultImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "setImplementation",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class Factory__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(admin, _savingsVaultImplementation, overrides) {
        return super.getDeployTransaction(admin, _savingsVaultImplementation, overrides || {});
    }
    deploy(admin, _savingsVaultImplementation, overrides) {
        return super.deploy(admin, _savingsVaultImplementation, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.Factory__factory = Factory__factory;
